import { DownloadOutlined, EyeOutlined, SendOutlined } from "@ant-design/icons";
import { Button, Modal, Select, Tag, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import pdfdisable from "../../assets/pdf-disable.png";
import pdf from "../../assets/pdf.png";
import { hasEditPermission } from "../../helpers/rabc-helper";
import { FETCH_LIVE_WELD_STATUS_SAGA } from "../../redux/data360LiveSlog/types";
import EmailForm from "../Common/EmailForm";
import CommonLoader from "../Loaders/loader";

const { Option } = Select;

const PQRReportContent = () => {
  const [selectedWeldNumbers, setSelectedWeldNumbers] = useState([]);
  const [isModalVisibletwo, setIsModalVisibletwo] = useState(false);
  const [emails, setEmails] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const reducerList = useSelector((state) => state);

  const canEdit = hasEditPermission(reducerList?.auth?.userDetails);

  const { weldStatusList } = useSelector(
    (state) => state.data360LiveSlogReducer
  );

  const weldnumber = weldStatusList.map((ite) => ite.weldNumber);
  const currentProject = useSelector(
    (state) => state?.data360LiveProjectReducer?.currentProject
  );
  const GeneratedData = useSelector(
    (state) => state?.data360LivePqrReducer?.pqrReportData
  );
  const isLoading = useSelector(
    (state) => state?.data360LivePqrReducer?.loading
  );

  const reportGeneratedData =
    GeneratedData?.pqrReports?.map((report) => ({
      id: report.id,
      weld_numbers: report.weld_numbers,
      boundary: report.boundary,
      weldReports:
        report.pass_view_reports?.map((weldReport) => ({
          weld_number: weldReport.weld_number,
          report_url: weldReport.report_url,
        })) || [],
      pqr_report_url: report.pqr_report_url,
    })) || [];

  const handleWeldNumberChange = (values) => {
    setSelectedWeldNumbers(values);
  };

  const handlePQRGenerayedReportClick = (weldNumber, boundary) => {
    history.push(
      `/data360-live-pqr-table-data/${weldNumber}?boundary=${boundary}`
    );
  };

  const handleClose = (removedNumber) => {
    setSelectedWeldNumbers((prevNumbers) =>
      prevNumbers.filter((number) => number !== removedNumber)
    );
  };

  useEffect(() => {
    if (currentProject?.project_id && currentProject?.project_name) {
      fetchData();
    }
  }, [dispatch, currentProject]);

  const fetchData = () => {
    dispatch({
      type: FETCH_LIVE_WELD_STATUS_SAGA,
      payload: {
        project_id: currentProject.project_id,
        project_name: currentProject.project_name,
      },
    });
  };
  const openDownloadModaltwo = () => {
    setIsModalVisibletwo(true);
  };

  const closeDownloadModaltwo = () => {
    setIsModalVisibletwo(false);
    setEmails([]);
  };

  const openSelectedDiv = () => {
    history.push(
      `/data360-live-pqr-table-data/${selectedWeldNumbers}?boundary=10`
    );
  };

  return (
    <>
      {isLoading ? (
        <div className="slogdata-loader">
          <CommonLoader />
        </div>
      ) : (
        <>
          <div className="pqr-report-div">
            <Select
              mode="multiple"
              placeholder="Select Weld Numbers"
              value={selectedWeldNumbers}
              onChange={handleWeldNumberChange}
              allowClear
              className="pqr-report"
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {weldnumber.map((number) => (
                <Option key={number} value={number}>
                  {number}
                </Option>
              ))}
            </Select>
            {selectedWeldNumbers.length > 0 && (
              <Button
                type="primary"
                className="pqrButton"
                onClick={() => openSelectedDiv()}
              >
                PQR Report
              </Button>
            )}
            <div className="selected-weld-numbers">
              {selectedWeldNumbers.map((number) => (
                <Tag
                  key={number}
                  closable
                  onClose={() => handleClose(number)}
                  className="options-show"
                >
                  {number}
                </Tag>
              ))}
            </div>
          </div>

          {reportGeneratedData.length > 0 && (
            <>
              <div className="header">
                <div>Sr.no</div>
                <div>Weld Number</div>
                <div>PassView Report</div>
                <div>Tolerance</div>
                <div>PQR Report</div>
              </div>

              {reportGeneratedData.map((report, index) => (
                <div className="pqr-gen-div" key={report.id}>
                  <div className="row">
                    <div className="sr_no">{index + 1}</div>
                    <div className="weld-numbers">
                      {report.weld_numbers
                        .split(",")
                        .map((weldNumber, index) => (
                          <span className="weld-number" key={index}>
                            <span className="weld-bg">{weldNumber.trim()}</span>{" "}
                          </span>
                        ))}
                    </div>
                    <div className="document-icons">
                      {report.weld_numbers
                        .split(",")
                        .map((weldNumber, index) => {
                          const weldReport = report.weldReports.find(
                            (wr) => wr.weld_number === weldNumber.trim()
                          );
                          return weldReport ? (
                            <span className="document-icon" key={index}>
                              <Tooltip
                                title="Download PassView Report"
                                placement="top"
                              >
                                <a
                                  href={weldReport.report_url.split("?")[0]}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={pdf}
                                    alt="Pdf"
                                    className="Passvie-pdf"
                                  />
                                </a>
                              </Tooltip>
                            </span>
                          ) : (
                            <span className="document-icon">
                              <Tooltip
                                title="PassView Report has not been generated yet."
                                placement="top"
                              >
                                <img
                                  src={pdfdisable}
                                  alt="Pdf-disabled"
                                  className="Pdf-disabled"
                                />
                              </Tooltip>
                            </span>
                          );
                        })}
                    </div>
                    <div className="percentage">
                      <span className="boundary-percetage">
                        {report.boundary}%
                      </span>
                    </div>
                    <div className="action-icons">
                      <span
                        className="viewanddownloadeye"
                        onClick={() =>
                          handlePQRGenerayedReportClick(
                            report.weld_numbers
                              .split(",")
                              .map((num) => num.trim()),
                            report.boundary
                          )
                        }
                      >
                        <Tooltip title="View PQR Report" placement="top">
                          <EyeOutlined />
                        </Tooltip>
                      </span>
                      {report.pqr_report_url ? (
                        <Tooltip title="Download PQR Report" placement="top">
                          <span className="viewanddownload">
                            <DownloadOutlined />
                          </span>
                        </Tooltip>
                      ) : (
                        <Tooltip
                          title="PQR Report has not been generated yet"
                          placement="top"
                        >
                          <span className="viewanddownload-disable">
                            <DownloadOutlined />
                          </span>
                        </Tooltip>
                      )}
                      {report.pqr_report_url ? (
                        <>
                          {canEdit && (
                            <Tooltip title="Share PQR Report" placement="top">
                              <span
                                className="share-pqr-report"
                                onClick={openDownloadModaltwo}
                              >
                                <SendOutlined />
                              </span>
                            </Tooltip>
                          )}
                        </>
                      ) : (
                        <Tooltip
                          title="PQR Report has not been generated yet"
                          placement="top"
                        >
                          <span className="share-pqr-report-disable">
                            <SendOutlined />
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}

          <Modal
            title={t("sLogData.shareReport")}
            open={isModalVisibletwo}
            onCancel={closeDownloadModaltwo}
            className="report-modal-style"
            width={600}
            footer={[
              <Button key="cancel" onClick={closeDownloadModaltwo}>
                Cancel
              </Button>,
              <Button
                key="download"
                type="primary"
                disabled={emails.length === 0}
              >
                Send
              </Button>,
            ]}
          >
            <EmailForm emails={emails} setEmails={setEmails} />
          </Modal>
        </>
      )}
    </>
  );
};

export default PQRReportContent;
